/**
 * formatTimeAgo — compact, English-only "x time ago" for ISO timestamps.
 *
 * Used by the "Last updated …" stamp under offers/events on
 * BusinessDetail.jsx. Conservative thresholds so the copy reads naturally:
 *   - < 60s          → "just now"
 *   - < 60 min       → "N min ago"
 *   - < 24 h         → "N hr ago"
 *   - < 7 days       → "N days ago"
 *   - < 5 weeks      → "N weeks ago"
 *   - < 12 months    → "N months ago"
 *   - else           → "N years ago"
 *
 * Returns null when the input can't be parsed so the caller can skip render.
 */
export const formatTimeAgo = (iso, now = new Date()) => {
  if (!iso) return null;
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return null;

  const seconds = Math.max(0, Math.floor((now.getTime() - then.getTime()) / 1000));
  if (seconds < 60) return 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return days === 1 ? '1 day ago' : `${days} days ago`;

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return months === 1 ? '1 month ago' : `${months} months ago`;

  const years = Math.floor(days / 365);
  return years === 1 ? '1 year ago' : `${years} years ago`;
};

export default formatTimeAgo;
